import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import { FcmService } from './services/FCM/fcm.service';
import { jwtDecode } from "jwt-decode";

import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { ApiService } from './services/API/api.service';
import { HttpErrorResponse } from '@angular/common/http';

declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit {
    location: any;
    routerSubscription: any;
    fcmToken: string | null = null;
    userLogged: string = '';
    constructor(private fcmService: FcmService,private router: Router,private api: ApiService) {
        this.getToken()
    }

    async getToken() {
        this.userLogged = localStorage.getItem('userLogged')
        if(this.userLogged == 'true'){
            // this.router.navigate(['/']);
            localStorage.removeItem('FCM_Token')
        }else{
            const fcm = localStorage.getItem('FCM_Token')
            if(!fcm){
                this.fcmToken = await this.fcmService.getFcmToken();
                localStorage.setItem('FCM_Token',this.fcmToken)
            }
        }
    }

    decodedToken:any
    quantity: number = 0;
    ngOnInit(){
        this.recallJsFuntions();

        const token = localStorage.getItem('userToken')
        if(token){
            // console.log('hhhhhhhhh')
            this.decodedToken = jwtDecode(localStorage.getItem('userToken'));
            const exp = localStorage.getItem('exp')
            if(!exp){
                localStorage.setItem('exp',this.decodedToken['exp'])
            }
            // this.api.getMyCart().subscribe({
            //     next: (response) => {
            //         console.log(response.data)
            //         this.quantity = response.data.map( item => item.quantity).reduce((a, b) => a + b, 0)
            //         console.log(this.quantity)
            //         localStorage.setItem('quantity',this.quantity.toString())
            //     }, error: (error: HttpErrorResponse) => {
            //         console.log(error)
            //     }
            // })
        }
    }

    recallJsFuntions() {
        this.router.events
        .subscribe((event) => {
            if ( event instanceof NavigationStart ) {
                $('.preloader').fadeIn('slow');
            }
        });
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            $.getScript('../assets/js/custom.js');
            $('.preloader').fadeOut('slow');
            this.location = this.router.url;
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }
}